import { motion } from "framer-motion";

const sections = [
  {
    title: "Hakkımda",
    content: [
      "Psikolojik Danışmanlık ve Rehberlik (PDR) lisans eğitimini yüksek onur derecesiyle tamamlamıştır. Klinik Psikoloji yüksek lisans eğitimini burslu olarak tamamlamıştır. Mesleki gelişimi doğrultusunda farklı psikoterapi ekollerine yönelik kapsamlı eğitimler almış ve süpervizyon süreçlerinden geçerek uzmanlık alanını derinleştirmiştir.",
      "Her bireyin yaşadığı deneyimin kendine özgü olduğunu ve terapi sürecinin kişiye özel ilerlemesi gerektiğini benimsemektedir. Bu nedenle çalışmalarında, danışanın ihtiyaçlarını merkeze alan, güvenli ve yargısız bir alan oluşturmayı öncelikli görmektedir.",
      "Bilimsel temelli ve etik ilkelere dayanan bir yaklaşım ile çalışırken, terapi sürecini yalnızca sorunların ele alındığı bir alan olarak değil; aynı zamanda kişinin kendini daha iyi anlamasına, duygularını düzenleyebilmesine ve yaşamında daha dengeli bir yapı kurabilmesine alan açan bir süreç olarak değerlendirmektedir.",
      "Çalışmalarını yetişkin, çocuk, ergen, aile ve kurumsal firmalarla sürdürmektedir.",
    ],
  },
  {
    title: "Akreditasyon ve Uygulama Alanları",
    content: ["EMDR Avrupa Akredite Uygulayıcısıdır", "(Çocuk, ergen ve yetişkin)"],
  },
];

const educationGroups = [
  {
    title: "Travma ve EMDR Odaklı Eğitimler",
    items: [
      "EMDR I. ve II. Düzey Eğitimleri – Emre Konuk & Asena Yurtsever",
      "Çocuk ve Ergenlerle EMDR I. ve II. Düzey Eğitimleri – Prof. Dr. Ümran Korkmazlar",
      "EMDR R-TEP Eğitimi – Uzman Klinik Psikolog / EMDR Avrupa Kıdemli Eğitmen ve Süpervizör Asena Yurtsever",
      "Travmayı Anlamak – Uzman Klinik Psikolog / EMDR Avrupa Kıdemli Eğitmen ve Süpervizör Asena Yurtsever",
      "EMDR Flash Tekniği Eğitimi – DBE / EMDR Avrupa Akredite Eğitmeni Uzman Psikolog Emre Konuk",
      "EMDR’de Grup Flash Eğitimi – Psikolojik Danışman Hayal Demirci",
      "EMDR Kısa Süreli Performans Geliştirme Protokolü – Davranış Bilimleri Enstitüsü",
      "EMDR Kayıp ve Yas Protokolü Eğitimi – Davranış Bilimleri Enstitüsü",
      "EMDR Dürtü-Kronik Ağrı ve Fibromiyalji Eğitimi – Davranış Bilimleri Enstitüsü",
      "EMDR ile Yetişkinlerde Bağlanma Sorunları Üzerine Çalışmak – Asena Yurtsever & Dr. Psikolog Ayşe Bombacı",
      "EMDR ve Bağlanma Odaklı Oyunlar – Prof. Dr. Ümran Korkmazlar",
      "EMDR ve İyileştiren Hikâye Eğitimi – Prof. Dr. Ümran Korkmazlar",
      "Çocuk-Ergen Grup EMDR – Prof. Dr. Ümran Korkmazlar",
      "EMDR Bilişsel Müdahaleler Eğitimi – Uzm. Psk. Şirin Atçeken (EMDR Avrupa Akredite Eğitmen ve Süpervizörü)",
      "EMDR’da Ustalaşmak II (Zor Vakalar ve Disosiyasyon ile Çalışmak) – Uzm. Psk. Şirin Atçeken",
      "EMDR’da Ustalaşmak III (Terapide Engeller, Savunmalar ve Dirençle Çalışmak) – Uzm. Psk. Şirin Atçeken",
      "EMDR’da Ustalaşmak IV (Somatik Müdahaleler ve Bedenle Çalışmak) – Uzm. Psk. Şirin Atçeken",
      "EMDR Terapisi ile Yeme Bozukluklarının Sağaltımı – EMDR Avrupa Akredite Eğitmeni Natalia Seijo",
      "İçsel Parçalar ve EMDR – Dr. Zeynep Tat / EMDR Avrupa Akredite Eğitmen ve Süpervizörü",
      "EMDR ile İlişkilerde Müdahale Programı – Dr. Zeynep Tat / EMDR Avrupa Akredite Eğitmen ve Süpervizörü",
      "TR-V-OCD EMDR Protokolü ile OKB Tedavisi – Uzman Klinik Psikolog Zeynep Özmedyan",
      "Travma Odaklı Yaşam Öyküsü Alma, EMDR Terapi Planı ve Vaka Formülasyonunun İncelikleri – EMDR Avrupa Akredite Süpervizör ve Danışmanı Psk. Pelin Öztaş",
      "Çocukları ve Ebeveynleri EMDR Terapisi İçin Hazırlamak (1, 2, 3 ve 4 olmak üzere tüm webinar serisi / çocuk EMDR terapistinin triatlonu serisi) – Uzm. Psk. Pınar Fidancı",
      "Çocuk ve Ergenlerde Bağlanma Travmaları ve EMDR Çalıştayı – EMDR Avrupa Consultant Derya Altınay",
    ],
  },
  {
    title: "Bilişsel Davranışçı Terapi (BDT) ve Diğer Yaklaşımlar",
    items: [
      "50 saatlik Bilişsel ve Davranışçı Terapi Kuramsal Eğitimi – Prof. Dr. M. Hakan Türkçapar",
      "Çocuk ve Ergenlerde Bilişsel Davranışçı Terapi Eğitimi – Psikiyatrist Prof. Dr. Vahdet Görmez",
      "Çocuk ve Ergenlerde Bilişsel Davranışçı Terapi Eğitimi Süpervizyonu (70 saat) – Psikiyatrist Prof. Dr. Vahdet Görmez",
      "Kısa Süreli Çözüm Odaklı Terapi – Uzman Klinik Psikolog Bayram Şimşek",
    ],
  },
  {
    title: "Şema Terapi",
    items: ["Uluslararası Şema Terapi Eğitimi – Dr. Alp Karaosmanoğlu"],
  },
  {
    title: "Dinamik Psikoterapi ve Kişilik Çalışmaları",
    items: [
      "Dinamik Psikoterapi Temel Eğitimi (1. Modül) – Prof. Dr. Doğan Şahin",
      "Borderline Kişilik Örgütlenmesi Aktarım Odaklı Dinamik Psikoterapi Eğitimi (2. Modül) – Prof. Dr. Doğan Şahin",
      "Üst Düzey (Nevrotik) Kişiliklerde Dinamik Psikoterapi Eğitimi (3. Modül) – Prof. Dr. Doğan Şahin",
      "Dinamik Terapi Yönelimli Cinsel Terapi Seminerleri – Prof. Dr. Doğan Şahin",
      "Kişilik Bozukluklarında Psikoterapi Eğitimi – Dr. Ferah Dayı",
    ],
  },
  {
    title: "Aile Terapisi",
    items: [
      "Bağlanma Temelli Aile Terapisi (ABFT) – Dr. Suzanne Levy",
    ],
  },
  {
    title: "Çocuk ve Ergen Psikolojisi ve Oyun Terapisi",
    items: [
      "Deneyimsel Oyun Terapisi I. ve II. Düzey Eğitimi – Dr. Byron Norton & Nilüfer Devecigil",
      "Deneyimsel Oyun Terapisinde Süpervizyon Konuları ve Kavramları – Dr. Byron Norton",
      "Deneyimsel Oyun Terapisinde Oyuncakların Sembolik Anlamları – Dr. Byron Norton",
      "Deneyimsel Oyun Terapisinde Güveni Sunma ve Bağlılık Aşaması – Dr. Byron Norton",
      "Deneyimsel Oyun Terapisinde Travmanın Somatik İfadeleri – Dr. Byron Norton",
      "Deneyimsel Oyun Terapisinde Çocukların Metaforik İfadeleri – Dr. Byron Norton",
      "Deneyimsel Oyun Terapisinde Hayvanların, Rollerinin ve Çevresel Koşulların Sembolik Anlamları – Dr. Byron Norton",
      "Deneyimsel Oyun Terapisinde Çocuklarla Çalışmak: Aile İçi Şiddetin Çocuklardaki Etkisi – Dr. Byron Norton",
      "Deneyimsel Oyun Terapisinde Ebeveyn Danışmanlığı – Dr. Byron Norton",
      "Deneyimsel Oyun Terapisinde Sık Sorulanlar – Uzman Klinik Psikolog Bahar Çakır",
      "Deneyimsel Oyun Terapisinde Dirençle Çalışmak – Uzman Klinik Psikolog Bahar Çakır",
      "Oyun Terapisinde Ebeveyne Geribildirim Vermek ve Sık Karşılaşılan Durumlar – Uzman Klinik Psikolog Bahar Çakır",
      "Çocuk Merkezli Oyun Terapisi – Uzman Klinik Psikolog Bayram Şimşek",
      "Çocukların Ruhsal Süreçlerinin Projektif Testlerle Değerlendirilmesi (Rorschach-CAT-TAT) Eğitimi – Doç. Dr. Neslihan Zabcı",
      "Çocukların Psikolojik Değerlendirilmesi ve Görüşme Teknikleri – Uzman Klinik Psikolog / Aile Danışmanı Yusuf Menki",
      "Çocuk Psikoterapisinde Beden ve Sinir Sistemi Merkezi Uygulamalar Seminerleri – Uzman Klinik Psikolog / EMDR Avrupa Akredite Terapisti İrem Polat",
      "Çocuklarla Ölüm Hakkında İletişim Kurmak Webinarı – Uzman Klinik Psikolog İrem Polat",
      "Ergenlik Dönemini Anlamak – Uzman Klinik Psikolog Bahar Çakır",
      "Ergenlerle Psikoterapi Uygulamaları – Uzman Klinik Psikolog Bahar Çakır",
      "Çocuklarda Kaygı ve Duygu Regülasyonu – Uzman Klinik Psikolog Bahar Çakır",
      "Çocuklarda Yeme ve Uyku Sorunlarına Bağlanma Temelli Yaklaşımlar – Uzman Klinik Psikolog Bahar Çakır",
      "Çocuk ve Genç Terapisinde Ebeveynleri Sürece Dahil Etmek – Uzman Klinik Psikolog Bahar Çakır",
      "Okulda Pozitif Disiplin – Uzman Klinik Psikolog Bahar Çakır",
      "Tuvalet Eğitimi ve Tuvalet Sorunlarına Terapötik Müdahaleler – Uzman Klinik Psikolog Bahar Çakır",
      "Tuvalet Geçişi ve Tuvalet Sorunlarına Oyuncu Yaklaşımlar – Uzman Klinik Psikolog Bahar Çakır",
      "Emzirmeyi Şefkatle Sonlandırmak – Uzman Klinik Psikolog Bahar Çakır",
      "Sağlıklı Ayrışma – Uzman Klinik Psikolog Bahar Çakır",
      "Çocukluk Döneminde Mastürbasyon – Uzman Klinik Psikolog Bahar Çakır",
    ],
  },
  {
    title: "Psikolojik Testler ve Değerlendirme",
    items: [
      "Minnesota Çok Yönlü Kişilik Envanteri (MMPI) – Bilgelik Enstitüsü",
      "Klinik Ölçme ve Değerlendirme Eğitimi / Özgül Öğrenme Bozukluğu Bataryası – Uzman Psikolog Sevil Turgut Turan",
      "MOXO Dikkat Testi – MOXO Türkiye",
      "Denver II Gelişimsel Tarama Testi – KİM Psikoloji",
      "Ankara Gelişim Tarama Envanteri – Uzman Klinik Psikolog Yusuf Menki",
      "Marmara Okul Olgunluğu Testi – Uzman Klinik Psikolog Yusuf Menki",
      "Metropolitan Okul Olgunluk Testi – Uzman Klinik Psikolog Yusuf Menki",
      "Gessell Gelişim Figürleri Testi – Uzman Klinik Psikolog Yusuf Menki",
      "Goodenough-Harris Bir Adam Çiz Testi – Uzman Klinik Psikolog Yusuf Menki",
      "Peabody Resim-Kelime Testi – Uzman Klinik Psikolog Yusuf Menki",
      "Bender-Gestalt Görsel Motor Algılama Testi – Uzman Klinik Psikolog Yusuf Menki",
      "Benton Görsel Bellek Testi – Uzman Klinik Psikolog Yusuf Menki",
      "Görsel Mekânsal Biliş ve Yönetici İşlevler Test Eğitimi WCST (Wisconsin Kart Eşleme Testi) Eğitimi – Prof. Dr. Emel Erdoğan Bakar",
      "Görsel Mekânsal Biliş ve Yönetici İşlevler Test Eğitimi RSPM (Raven Standart Progresif Matrisler Testi) Eğitimi – Prof. Dr. Emel Erdoğan Bakar",
      "Görsel Mekânsal Biliş ve Yönetici İşlevler Test Eğitimi ÇYBT (Çizgi Yönü Belirleme Testi) Eğitimi – Prof. Dr. Emel Erdoğan Bakar",
    ],
  },
  {
    title: "Diğer Klinik ve Gelişimsel Eğitimler",
    items: [
      "Hipnoz Eğitimi – Dr. Aykut Yıkın",
      "Hipnoz ve Kişisel Gelişim Çalışmalarına Katılım – Doç. Dr. İbrahim Ethem Ay",
      "Disleksi Eğitici Eğitim Programı – Öğretim Üyesi Celil Soylan",
      "Prep – Akademi Disleksi",
      "Türkçe Math Uygulayıcı Eğitimi – Akademi Disleksi",
      "Akıl ve Zeka Oyunları Eğitimi – İstanbul International Yeditepe Üniversitesi Sürekli Eğitim Merkezi",
      "Yaratıcı Drama Eğitmenliği – Uludağ Üniversitesi",
      "Hafıza Teknikleri Eğitmenliği – Uludağ Üniversitesi",
      "Çocuk Resimleri Analizi ve Psikolojik Resim Testleri Eğitimi – Dr. Sultanberk Halmatov",
      "Öğrencilerin İstenmeyen Davranışlarını Yönetme – Dr. Oktay Aydın",
      "Zor Velilerle İletişim – Dr. Oktay Aydın",
    ],
  },
];

export default function Hakkimda() {
  return (
    <section className="bg-white px-6 py-20 sm:py-24 lg:px-12">
      <div className="mx-auto max-w-5xl">
        <div className="space-y-12">
          {sections.map((section, index) => (
            <motion.div
              key={section.title + index}
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              className="rounded-3xl border border-gray-200 p-6 sm:p-8 shadow-sm"
            >
              <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-5">
                {section.title}
              </h2>

              <div className="space-y-4 text-base sm:text-lg text-gray-700 leading-relaxed">
                {section.content.map((paragraph, i) => (
                  <p key={i}>{paragraph}</p>
                ))}
              </div>
            </motion.div>
          ))}

          <motion.div
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="rounded-3xl border border-gray-200 p-6 sm:p-8 shadow-sm"
          >
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-8">
              Katıldığı Eğitimler
            </h2>

            <div className="space-y-10">
              {educationGroups.map((group, idx) => (
                <div key={group.title + idx}>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    {group.title}
                  </h3>

                  <ul className="space-y-3 text-gray-700 leading-relaxed">
                    {group.items.map((item, i) => (
                      <li key={i} className="flex gap-3">
                        <span className="mt-2 h-2 w-2 shrink-0 rounded-full bg-gray-400" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}